export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/5ba84b7c5997e2a9223c26a23a6fa17e.svg";